import {useInfiniteQuery, useQuery} from "@tanstack/react-query";
import * as api from "../../../api";


const PAGE_SIZE = 50;

export const useMunicipalityInfiniteQuery = (filter, enabled=true) => {
    return useInfiniteQuery({
        queryKey: ['municipalities', filter],
        queryFn: async ({pageParam=0}) => {
            const data = await api.Territory.getMunicipalities({...filter, page_index: pageParam, page_size: PAGE_SIZE});
            return {
                items: data.rows,
                nextPage: data.rows.length === PAGE_SIZE ? pageParam + 1 : undefined,
            };
        },
        getNextPageParam: (lastPage) => lastPage.nextPage,
        enabled: enabled,
    });
}

export const useMunicipalityQuery = (municipalityId, options) => {
    return useQuery({
        queryKey: ['municipality', municipalityId],
        queryFn: async () => {
            const data = await api.Territory.getMunicipality(municipalityId);
            return data;
        },
        enabled: municipalityId !== null && municipalityId !== undefined,
        ...options
    });
}